module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1